import { Injectable } from '@angular/core';
import { ErrorReporter } from '@mode/shared/types-common';
import * as _uriTemplate from 'uri-templates';
import * as _urlTemplate from 'url-template';
import { Template, TemplateParser } from './uri-template-parser.types';

@Injectable({ providedIn: 'root' })
export class DualDispatchUriTemplateService implements TemplateParser {
  constructor(private errorReporter: ErrorReporter) {}

  parse(template: string): Template {
    const parsed = _urlTemplate.parse(template);
    return {
      expand: (parameters: any) => {
        const urlTemplateString = parsed.expand(parameters);
        try {
          const uriTemplateString = _uriTemplate(template).fill(parameters);

          if (uriTemplateString !== urlTemplateString) {
            const error = {
              name: `URI template difference`,
              message: `\nuri-templates => ${uriTemplateString}\nurl-template => ${urlTemplateString}`,
            };
            this.errorReporter.notify({ error });
          }

          return urlTemplateString;
        } catch (error: any) {
          //
          //  We're catching here because we don't want to
          //  kill normal use of uri-templates#expand if
          //  something goes awry in url-template#fill
          //  as we learn if url-template#fill works
          //  identically to uri-templates#expand or not.
          //
          this.errorReporter.notify({ error });

          return urlTemplateString;
        }
      },
    };
  }
}
